import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center px-4 py-32 text-center sm:px-6 lg:px-8">
      <span className="text-6xl">404</span>
      <h1 className="mt-4 text-3xl font-bold tracking-tight">Pagina no encontrada</h1>
      <p className="mt-2 text-text-secondary">
        Lo sentimos, no encontramos lo que estabas buscando.
      </p>
      <Link to="/" className="btn-primary mt-8">
        Volver al inicio
      </Link>
    </div>
  );
}
